import { createContext, useContext } from 'react';
import { IState } from '../../../store/modules/root/state.interface';

export const initialState: IState = {
  help: {
    data: {
      url: null,
    },
    loading: false,
    error: undefined,
    displayed: false,
  },
  auth: {
    data: {
      user_id: null,
      accessToken: null,
      accessTokenExpiry: null,
      tenant: '',
    },
    loading: false,
    error: undefined,
  },
  authType: {
    data: null,
    loading: false,
    error: undefined,
    loaded: false,
  },
  currentUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  pickedUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
    },
    loading: false,
    error: undefined,
  },
  users: {
    data: [],
    loading: false,
    error: undefined,
  },
  roles: {
    data: [],
    loading: false,
    error: undefined,
  },
  tenants: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  zones: {
    data: {
      data: [],
      propertyNames: [],
      count: 0,
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  zonesNew: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  zonesForMaps: {
    data: {
      limit: 0,
      skip: 0,
      count: 0,
      recordsMap: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  facilities: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  groupTypes: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  allColumnsOfReport: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  reportCollections: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  groupsByTypes: {
    data: {
      region: [],
      campus: [],
      facility: [],
      zone: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  groups: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  groupsTree: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  assetType: {
    data: {
      id: 0,
      tenant: '',
      code: '',
      description: '',
      properties: [],
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
  assetTypes: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  assetTypeProperties: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  reportsTree: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  preparedReport: {
    data: {
      execution_time_millis: 0,
      name: '',
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  copiedReport: {
    data: {
      id: 0,
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  reports: {
    data: [],
    loading: false,
    error: undefined,
  },
  report: {
    data: {
      id: 0,
      reportGroup_id: null,
      code: '',
      name: '',
      tenant: '',
      collection: '',
      description: '',
      find: null,
      sort: null,
      aggregate: null,
    },
    loading: false,
    error: undefined,
  },
  execReport: {
    data: {
      code: '',
      name: '',
      description: '',
      filter: '',
      sort: '',
      limit: 0,
      skip: 0,
      count: 0,
      fields: [],
      headers: [],
      columnStyles: [],
      records: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  executedReport: {
    data: {
      id: 0,
      tenant: '',
      code: '',
      name: '',
      collection: '',
      description: '',
      columns: [],
      find: '',
      sort: '',
      aggregate: '',
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  reportQuickRanges: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  columns: {
    data: [],
    loading: false,
    error: undefined,
  },
  regex: {
    data: [],
    loading: false,
    error: undefined,
  },
  logicalReaders: {
    data: {},
    loading: false,
    error: undefined,
  },
  devices: {
    data: [],
    loading: false,
    error: undefined,
  },
  polygons: {
    data: [],
    loading: false,
    error: undefined,
  },
  listsForReport: {
    data: {
      regex: [],
      quickRanges: [],
      operators: [],
      filterFields: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  reportFieldSuggestions: {
    data: {},
    loading: false,
    error: undefined,
  },
  mapOrigin: {
    data: {
      id: undefined,
      group_id: '',
      name: '',
      longitude: '',
      latitude: '',
      elevation: '',
      azimuth: '',
      units: '',
    },
    loading: false,
    error: undefined,
  },
  mapImage: {
    data: {
      id: undefined,
      mapOrigin_id: '',
      xofffset: '',
      yoffset: '',
      theta: '',
      pixelsPerLength: '',
    },
    loading: false,
    error: undefined,
  },
  mapImageImage: {
    data: {},
    loading: false,
    error: undefined,
  },
  mapReportDefinition: {
    data: {
      id: 0,
      reportdef_id: 0,
      name: '',
      config: {},
    },
    loading: false,
    error: undefined,
  },
  mapReport: {
    data: {
      code: '',
      name: '',
      description: '',
      collection: '',
      filter: 'string',
      sort: '',
      limit: 0,
      count: 0,
      recordsMap: {},
    },
    loading: false,
    error: undefined,
  },
  mapControlsState: {
    data: {
      imageVisibility: true,
      zoneVisibility: true,
      pointsVisibility: true,
      pointLabelsVisibility: true,
      zoneLabelsVisibility: true,
      xyAxesVisibility: false,
      xyAxesLabelsVisibility: false,
      xyGridVisibility: false,
      llAxesVisibility: false,
      llAxisLabelsVisibility: false,
      llGridVisibility: false,
      canvasCenterVisibility: false,
      mapBoundingBoxVisibility: false,
      thetaDefinitionVisibility: false,
      pointCirclesVisibility: true,
      vectorsVisibility: false,
      vectors2Visibility: false,
      zoomVisibility: false,
      imageTransparencyRangeValue: 1.0,
      pointsTransparencyRangeValue: 1.0,
      zonesTransparencyRangeValue: 1.0,
      xyAxisTransparencyRangeValue: 1.0,
      xyGridTransparencyRangeValue: 1.0,
      llAxisTransparencyRangeValue: 1.0,
      llGridTransparencyRangeValue: 1.0,
      rangeValue: 1.0,
    },
    loading: false,
    error: undefined,
  },
  timeZones: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  tenantRules: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  tenantRulesSchema: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  rulesFields: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  rulesPseudocode: {
    data: '',
    loading: false,
    error: undefined,
    loaded: false,
  },
  tenantRulesSaveState: {
    data: null,
    loading: false,
    error: undefined,
    loaded: false,
  },
  forgottenPasswordChange: {
    data: false,
    loading: false,
    error: undefined,
    loaded: false,
  },
  zonesSaveState: {
    data: null,
    loading: false,
    error: undefined,
    loaded: false,
  },
  rulesConfig: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  mermaidDiagram: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  tenantProperties: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  wrappedSchema: {
    data: {},
    loading: false,
    error: undefined,
    loaded: false,
  },
  permission: {
    data: [],
    loading: false,
    error: undefined,
    loaded: false,
  },
  rulesData: {
    data: {
      rules: [],
      statements: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  transformsData: {
    data: {
      rules: [],
      statements: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  systemConfigData: {
    data: {
      rules: [],
      statements: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
  scheduledRulesData: {
    data: {
      rules: [],
      statements: [],
    },
    loading: false,
    error: undefined,
    loaded: false,
  },
};

export const StateContext = createContext<IState>(initialState);
export const useStore = (): IState => useContext<IState>(StateContext);

export default StateContext;
